// src/config/modules.js
//
// Source unique des 5 modules du SaaS.
// Utilisé par AppHomePage (grille d'accueil) et OnboardingGuide (visite guidée)
// pour éviter que les deux listes divergent avec le temps.

import {
  FileText,
  Search,
  Scale,
  FileBadge,
  Briefcase,
} from 'lucide-react';

export const MODULES = [
  {
    key:   'fiche_poste',
    title: 'Fiche de Poste',
    desc:  'Transformez vos notes en fiches professionnelles structurées.',
    path:  '/fiche-poste',
    Icon:  FileText,
    color: 'blue',
  },
  {
    key:   'audit_cv',
    title: 'Audit CV',
    desc:  'Analysez la cohérence et la qualité de vos CV en un clic.',
    path:  '/analyse',
    Icon:  Search,
    color: 'violet',
  },
  {
    key:   'matching',
    title: 'Matching CV / AO',
    desc:  'Calculez le score de pertinence entre un CV et une offre.',
    path:  '/matching',
    Icon:  Scale,
    color: 'teal',
  },
  {
    key:   'generator',
    title: 'Générateur',
    desc:  'Produisez des dossiers de compétences complets automatiquement.',
    path:  '/process',
    Icon:  FileBadge,
    color: 'amber',
  },
  {
    key:   'job_search',
    title: "Recherche d'Offres",
    desc:  'Explorez et trouvez des missions adaptées à vos profils.',
    path:  '/job-search',
    Icon:  Briefcase,
    color: 'rose',
  },
];

/**
 * Détermine si l'utilisateur a accès à un module donné.
 * Reproduit la même logique que celle déjà utilisée dans AppHomePage / Navbar :
 * si la clé de permission n'est pas définie, l'accès est autorisé par défaut.
 */
export const hasModuleAccess = (user, moduleKey) => {
  if (!user) return false;
  if (user.permissions && typeof user.permissions[moduleKey] !== 'undefined') {
    return user.permissions[moduleKey];
  }
  return true;
};

/** Renvoie la liste des modules accessibles à l'utilisateur, dans l'ordre défini ci-dessus. */
export const getAccessibleModules = (user) =>
  MODULES.filter((m) => hasModuleAccess(user, m.key));